const LAST_FOUR = 4;

export const maskCardNumber = (value) => {
  const digits = String(value ?? '').replace(/\D/g, '');

  if (!digits) return '';

  return `**** ${digits.slice(-LAST_FOUR)}`;
};

export const getCardLabel = (transaction, fallback = 'Card') => {
  const masked = maskCardNumber(transaction?.cc_number);
  const type = transaction?.cc_type || fallback;

  return masked ? `${type} ${masked}` : type;
};
